import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";

import WizardDetailsPanel from "./detailsPanel/WizardDetailsPanel.jsx";
import OTPPanel from "./OTPPanel/OTPPanel.jsx";
import RequiredOptionPanel from "./requiredOptionPanel/RequiredOptionPanel.jsx";
import ResourcePanel from "./resourcePanel/ResourcePanel.jsx";
import RegionPanel from "./regionPanel/RegionPanel.jsx";
import SSHPanel from "./SSHPanel/SSHPanel.jsx";
import ResourceBlock from "./resourcePanel/ResourceBlock.jsx";
import VPNBlock from "../vpns/VPNBlock.jsx";
import CIDRPanel from "./CIDRPanel/CIDRPanel.jsx";
import SummaryPanel from "./summaryPanel/SummaryPanel.jsx";
import EstimatePanel from "./estimatePanel/EstimatePanel.jsx";

import { PANEL_TYPES } from "../../state/reducers/projectWizard/projectWizardConstants.js";
import { AT_TYPES } from "../../constants/entity.js";

class PanelMap extends PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    provider: PropTypes.object,
    providersList: PropTypes.array.isRequired,
    region: PropTypes.object,
    regionsList: PropTypes.array.isRequired,
    zone: PropTypes.object,
    zonesList: PropTypes.array.isRequired,
    limits: PropTypes.object.isRequired,
    configCopyKey: PropTypes.string.isRequired
  };

  static defaultProps = {
    limits: {}
  };

  getCopyKeys = key => {
    const { configCopyKey } = this.props;

    if (!key) return null;

    const keys = {
      copyKey: `project_wizard.${key}`
    };

    if (configCopyKey) {
      keys.configCopyKey = `${configCopyKey}.${key}`;
    }

    return keys;
  };

  getPanelMap = () => {
    const { provider, providersList, region, regionsList, zone, zonesList } =
      this.props;

    return {
      [PANEL_TYPES.DETAILS]: {
        component: WizardDetailsPanel,
        panelProps: {
          ...this.getCopyKeys("details_panel")
        }
      },
      [PANEL_TYPES.OTP]: {
        component: OTPPanel,
        panelProps: {
          name: "requiresUserVerification",
          ...this.getCopyKeys("otp_panel")
        }
      },
      [PANEL_TYPES.PROVIDER]: {
        component: RequiredOptionPanel,
        panelProps: {
          name: "provider",
          options: providersList,
          selected: provider,
          ...this.getCopyKeys("provider_panel")
        }
      },
      [PANEL_TYPES.REGION]: {
        component: RegionPanel,
        panelProps: {
          name: "region",
          regionOptions: regionsList,
          zoneOptions: zonesList,
          selectedRegion: region,
          selectedZone: zone,
          ...this.getCopyKeys("region_panel")
        }
      },
      [PANEL_TYPES.WORKSTATION]: {
        component: ResourcePanel,
        panelProps: {
          resourceType: AT_TYPES.WORKSTATION,
          blockComponent: ResourceBlock,
          enableMultiples: true,
          ...this.getCopyKeys("workstation_panel")
        }
      },
      [PANEL_TYPES.STORAGE]: {
        component: ResourcePanel,
        panelProps: {
          resourceType: AT_TYPES.CONTAINER,
          blockComponent: ResourceBlock,
          ...this.getCopyKeys("storage_panel")
        }
      },
      [PANEL_TYPES.RENDER_MANAGER]: {
        component: ResourcePanel,
        panelProps: {
          resourceType: AT_TYPES.DATABASE,
          blockComponent: ResourceBlock,
          ...this.getCopyKeys("render_manager_panel")
        }
      },
      [PANEL_TYPES.NODE]: {
        component: ResourcePanel,
        panelProps: {
          resourceType: AT_TYPES.NODE,
          blockComponent: ResourceBlock,
          enableMultiples: true,
          ...this.getCopyKeys("node_panel")
        }
      },
      [PANEL_TYPES.SNOWFLAKE]: {
        component: ResourcePanel,
        panelProps: {
          resourceType: AT_TYPES.SNOWFLAKE,
          blockComponent: ResourceBlock,
          ...this.getCopyKeys("snowflake_panel")
        }
      },
      [PANEL_TYPES.SSH]: {
        component: SSHPanel,
        panelProps: {
          resourceType: AT_TYPES.SSH_KEY,
          ...this.getCopyKeys("ssh_panel")
        }
      },
      [PANEL_TYPES.CIDR]: {
        component: CIDRPanel,
        panelProps: {
          ...this.getCopyKeys("cidr_panel")
        }
      },
      [PANEL_TYPES.DISPLAY_GATEWAY]: {
        component: ResourcePanel,
        panelProps: {
          resourceType: AT_TYPES.DISPLAY_GATEWAY,
          blockComponent: ResourceBlock,
          ...this.getCopyKeys("display_gateway_panel")
        }
      },
      [PANEL_TYPES.VPN_GATEWAY]: {
        component: ResourcePanel,
        panelProps: {
          resourceType: AT_TYPES.VPN_GATEWAY,
          blockComponent: VPNBlock,
          ...this.getCopyKeys("vpn_panel")
        }
      },
      [PANEL_TYPES.SUMMARY]: {
        component: SummaryPanel,
        panelProps: {
          ...this.getCopyKeys("summary_panel")
        }
      },
      [PANEL_TYPES.ESTIMATE]: {
        component: EstimatePanel,
        panelProps: {
          ...this.getCopyKeys("estimate_panel")
        }
      }
    };
  };

  render() {
    const { type, ...props } = this.props;

    const panelMap = this.getPanelMap()[type];

    const Panel = panelMap.component;
    const panelProps = panelMap.panelProps;

    return <Panel {...props} {...panelProps} />;
  }
}

export default PanelMap;
